import AlrModelBase from '../_generated/modelBases/alr-model-base';

export default class AlrModel extends AlrModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
